export default __webpack_public_path__ + "static/media/Smart Heart Rabbit Food Wildberry.b5f3583f.png";